
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/ring",
      function () {
        return require("private-next-pages/casino/ring/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/ring"])
      });
    }
  